import { DisabledWithTooltip } from "./disabled-with-tooltip";

export function normalizeDisabledWithTooltip(
  disabled?: DisabledWithTooltip
): Exclude<DisabledWithTooltip, boolean> {
  if (!disabled) return { isDisabled: false };
  if (typeof disabled === "boolean") {
    return { isDisabled: disabled };
  }
  return disabled;
}
